import { useState, FormEvent } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from './AuthContext';

export default function LoginPage() {
  const { login } = useAuth();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [submitting, setSubmitting] = useState(false);

  async function handleSubmit(e: FormEvent) {
    e.preventDefault();
    setError('');
    setSubmitting(true);
    try {
      await login(username, password);
    } catch (err) {
      const detail =
        (err as { response?: { data?: { detail?: string } } })?.response
          ?.data?.detail;
      setError(
        detail || 'Giriş başarısız. Kullanıcı adı veya şifre hatalı.',
      );
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <div className="login-container">
      <Link to="/" className="login-home-btn" aria-label="Ana sayfaya dön">
        <span aria-hidden="true">←</span>
        <span>Ana Sayfa</span>
      </Link>
      <div className="login-card">
        <div className="login-header">
          <div className="logo-badge">🎓 Mulakid</div>
          <h1>Mulakid</h1>
          <p className="subtitle">Mezuniyet Projesi Mülakat Simülasyonu</p>
        </div>

        {error && <div role="alert" className="error">{error}</div>}

        <form onSubmit={handleSubmit} noValidate>
          <div className="form-field">
            <label htmlFor="username" className="form-label">Kullanıcı Adı</label>
            <input
              id="username"
              type="text"
              className="form-input"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              required
              autoFocus
              autoComplete="username"
              placeholder="Kullanıcı adınızı girin"
            />
          </div>

          <div className="form-field">
            <label htmlFor="password" className="form-label">Şifre</label>
            <input
              id="password"
              type="password"
              className="form-input"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              autoComplete="current-password"
              placeholder="Şifrenizi girin"
            />
          </div>

          <button
            type="submit"
            className="btn btn--primary btn--lg btn--block"
            disabled={submitting}
          >
            {submitting ? 'Giriş yapılıyor…' : 'Giriş Yap'}
          </button>
        </form>

        
      </div>
    </div>
  );
}
